import { Component, Input } from '@angular/core';
import { TableButton } from '@ca/core/models';

@Component({
    selector: 'ca-action-buttons',
    templateUrl: './action-buttons.component.html',
    styleUrls: ['./action-buttons.component.scss'],
})
export class ActionButtonsComponent {
    @Input() readonly buttons: TableButton[] = [];
    @Input() readonly item: TableButton;

    get nonDropdownButtons(): TableButton[] {
        return this.buttons.filter((b: TableButton) => !b.putInDropdownSubmenu);
    }

    get dropdownButtons(): TableButton[] {
        return this.buttons.filter((b: TableButton) => b.putInDropdownSubmenu);
    }
}
